<template>
    <div class="success-container">
        <div class="success-message">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
            <h1 v-if="!isSpecial">Yanıtınız Gönderildi!</h1>
            <p v-if="!isSpecial">Yanıtlarınız başarıyla gönderildi. Teşekkür ederiz!</p>
<!--            Betnano için özel tasarım-->
            <p v-if="isSpecial">Talebiniz alındı tarafınıza mail yoluyla kısa sürede geri dönüş sağlanacaktır.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "SubmitForm",
    data() {
        return {
            isSpecial: false,
        };
    },
    mounted() {
        const special = this.$route.query.special;
        if (special === "true") {
            this.isSpecial = true;
        }
    }
};
</script>

<style lang="scss">
.success-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.success-message {
    text-align: center;
    padding: 20px;
}

.checkmark {
    width: 100px;
    height: 100px;
    margin: 0 auto 20px;
}

.checkmark__circle {
    stroke: #34c759;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark__check {
    transform-origin: 50% 50%;
    stroke: #34c759;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.3s forwards;
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

h1 {
    font-size: 24px;
    margin-bottom: 10px;
    color: #333;
}

p {
    font-size: 16px;
    color: #666;
}
</style>